module.exports = __webpack_public_path__ + "static/media/374.7a85fefb.svg";